<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="!isLoading">
  <h2>{{ "forms.prescriptionDevice.bytefliesOrder" | translate }}</h2>
  <form [formGroup]="prescriptionDeviceForm">
    <mat-form-field style="width: 100%; max-width: 100%">
      <mat-label>{{ "forms.prescriptionDevice.selectDevice" | translate }}</mat-label>
      <mat-select formControlName="selectedDevice" (selectionChange)="onDeviceChange()">
        <mat-option [value]="undefined">- {{ "forms.null" | translate }} -</mat-option>
        <mat-option *ngFor="let device of devicesToOrder" [value]="device.name">
          {{ device.name + (device.devicesTypes?.length ? " (" + device.devicesTypes.join(", ") + ")" : "") }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="flexRow">
      <mat-form-field>
        <mat-label>{{ "forms.prescriptionDevice.name" | translate }}</mat-label>
        <input matInput formControlName="name" [placeholder]="'forms.prescriptionDevice.name' | translate" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "forms.prescriptionDevice.estimatedDays" | translate }}</mat-label>
        <input
          matInput
          type="number"
          formControlName="estimatedDays"
          [placeholder]="'forms.prescriptionDevice.estimatedDays' | translate"
        />
      </mat-form-field>
      <mat-form-field *ngIf="hasPatch">
        <mat-label>{{ "forms.prescriptionDevice.nbPatch" | translate }}</mat-label>
        <input matInput type="number" formControlName="nbPatch" [placeholder]="'forms.prescriptionDevice.nbPatch' | translate" />
      </mat-form-field>
    </div>
    <p>{{ "forms.prescriptionDevice.deliveryAddress" | translate }}</p>
    <div class="flexRow mt-1 mb-1">
      <button mat-raised-button *ngIf="patientAddress?.city" (click)="setAddress(patientAddress)">
        {{ "forms.prescriptionDevice.patientAddressBtn" | translate }}
      </button>
      <button mat-raised-button *ngIf="orgAddress?.city" (click)="setAddress(orgAddress)">
        {{ "forms.prescriptionDevice.orgAddressBtn" | translate }}
      </button>
    </div>

    <div class="address">
      <div class="flexRow">
        <mat-form-field>
          <mat-label>{{ "forms.prescriptionDevice.streetName" | translate }}</mat-label>
          <input matInput formControlName="streetName" [placeholder]="'forms.prescriptionDevice.streetName' | translate" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "forms.prescriptionDevice.streetNumber" | translate }}</mat-label>
          <input matInput formControlName="streetNumber" [placeholder]="'forms.prescriptionDevice.streetNumber' | translate" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "forms.prescriptionDevice.boxNumber" | translate }}</mat-label>
          <input matInput formControlName="boxNumber" [placeholder]="'forms.prescriptionDevice.boxNumber' | translate" />
        </mat-form-field>
      </div>
      <div class="flexRow">
        <mat-form-field>
          <mat-label>{{ "forms.prescriptionDevice.postalCode" | translate }}</mat-label>
          <input matInput formControlName="postalCode" [placeholder]="'forms.prescriptionDevice.postalCode' | translate" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "forms.prescriptionDevice.city" | translate }}</mat-label>
          <input matInput formControlName="city" [placeholder]="'forms.prescriptionDevice.city' | translate" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "forms.prescriptionDevice.country" | translate }}</mat-label>
          <input matInput formControlName="country" [placeholder]="'forms.prescriptionDevice.country' | translate" />
        </mat-form-field>
      </div>
    </div>
    <div class="flexRow">
      <p style="white-space: pre-line">{{ prescriptionDeviceForm | getDevicePrice : devicesToOrder }}</p>
    </div>
  </form>
</div>
